export default __webpack_public_path__ + "static/media/T760MAND5.ba93a60a.pdf";